const FILE_SIZE_EXPONENTS = {
  0: 'Б',
  1: 'Кб',
  2: 'Мб',
  3: 'Гб',
};

/** Парсим байты в удобный для чтения формат [ 9853 -> 9.62 Кб ]*/
export function getHumanReadableFileSize(sizeInBytes: number): string {
  let exponent = 0;

  let size = sizeInBytes;

  while (size > 1024) {
    size /= 1024;
    exponent++;
  }

  return `${size.toFixed(2)} ${FILE_SIZE_EXPONENTS[exponent]}`;
}
